// src/pages/shop_dashboard/UpdatePrompt.jsx
import { useEffect, useRef } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

const FAST_CHECK_INTERVAL = 4000; // ms
const FAST_CHECK_WINDOW = 30000; // ms
const SLOW_CHECK_INTERVAL = 60000; // ms

const UpdatePrompt = () => {
  const registrationRef = useRef(null);

  // needRefresh and updateServiceWorker are removed because
  // 'autoUpdate' handles activation and reloading automatically.
  useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      if (!registration) return;
      registrationRef.current = registration;
      registration.update().catch(() => {});
    },
    onRegisterError(error) {
      console.error('SW Registration error:', error);
    },
  });

  useEffect(() => {
    let fastTimer;
    let slowTimer;

    const runCheck = () => {
      if (document.visibilityState === 'visible' && registrationRef.current) {
        registrationRef.current.update().catch(() => {});
      }
    };

    runCheck();
    fastTimer = setInterval(runCheck, FAST_CHECK_INTERVAL);
    const switchToSlow = setTimeout(() => {
      clearInterval(fastTimer);
      slowTimer = setInterval(runCheck, SLOW_CHECK_INTERVAL);
    }, FAST_CHECK_WINDOW);

    document.addEventListener('visibilitychange', runCheck);
    window.addEventListener('focus', runCheck);

    return () => {
      clearInterval(fastTimer);
      clearInterval(slowTimer);
      clearTimeout(switchToSlow);
      document.removeEventListener('visibilitychange', runCheck);
      window.removeEventListener('focus', runCheck);
    };
  }, []);

  // Returns null because the component is now entirely logical.
  // The PWA plugin handles the hard reload automatically.
  return null;
};

export default UpdatePrompt;